import { render, staticRenderFns } from "./ModalAssignLegajo.vue?vue&type=template&id=606159ca"
import script from "./ModalAssignLegajo.vue?vue&type=script&lang=js"
export * from "./ModalAssignLegajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606159ca')) {
      api.createRecord('606159ca', component.options)
    } else {
      api.reload('606159ca', component.options)
    }
    module.hot.accept("./ModalAssignLegajo.vue?vue&type=template&id=606159ca", function () {
      api.rerender('606159ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/ModalAssignLegajo.vue"
export default component.exports